import { ActionTree, GetterTree, Module, MutationTree } from "vuex";

interface INavRoute {
  name: string;
  children: string[];
}

const STORAGE_KEY = "navRoutes";

function readRoutes(): INavRoute[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as INavRoute[]) : [];
  } catch {
    return [];
  }
}

const state: { router: INavRoute[] } = {
  router: readRoutes(),
};
const mutations: MutationTree<{ router: INavRoute[] }> = {
  CHANGE_ROUTER: (state: { router: INavRoute[] }, payload: INavRoute[]) => {
    state.router = payload;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  },
};
const actions: ActionTree<{ router: INavRoute[] }, IRootState> = {
  ACTION_CHANGE_ROUTER({ commit }, payload: INavRoute[]) {
    commit("CHANGE_ROUTER", payload);
  },
};
const getters: GetterTree<{ router: INavRoute[] }, IRootState> = {
  ROUTER_STATE(state: { router: INavRoute[] }) {
    return state.router;
  },
  FULL_ROUTES(state: { router: INavRoute[] }) {
    const ollRoutes: string[] = [];
    for (let i = 0; i < state.router.length; i++) {
      if (state.router[i].children.length > 0) {
        for (let j = 0; j < state.router[i].children.length; j++) {
          ollRoutes.push(state.router[i].children[j]);
        }
      } else {
        ollRoutes.push(state.router[i].name);
      }
    }
    return ollRoutes;
  },
};

export const router: Module<{ router: INavRoute[] }, IRootState> = {
  state,
  mutations,
  actions,
  getters,
};
